/** Makeup identity survives cancel/holiday (prior kind is cancelled_from_kind). */

export function isCancelledSession(row) {
  return String(row?.session_kind || 'regular') === 'cancelled';
}

export function isHolidaySession(row) {
  return String(row?.session_kind || 'regular') === 'holiday';
}

export function isMakeupSession(row) {
  const kind = String(row?.session_kind || 'regular');
  if (kind === 'makeup') return true;
  return (
    (kind === 'cancelled' || kind === 'holiday') &&
    String(row?.cancelled_from_kind || '') === 'makeup'
  );
}

/** Short label for pickers / calendar subtitles. */
export function sessionKindLabel(row) {
  if (isHolidaySession(row) && isMakeupSession(row)) return 'holiday makeup';
  if (isHolidaySession(row)) return 'holiday';
  if (isMakeupSession(row) && isCancelledSession(row)) return 'cancelled makeup';
  if (isMakeupSession(row)) return 'makeup';
  const kind = String(row?.session_kind || 'regular');
  if (kind === 'regular') return null;
  return kind;
}

/** Tile color key. Holiday stays holiday (paid day), distinct from leave and cancelled. */
export function sessionCalendarKind(row) {
  if (isHolidaySession(row)) return 'holiday';
  if (isMakeupSession(row)) return 'makeup';
  const kind = String(row?.session_kind || 'regular');
  if (kind === 'cancelled') return 'cancelled';
  return kind;
}
